import { useEffect, useState } from "react";
import GetFetch from "../../hooks/GetFetch";
import PutPostPatchFetch from "../../hooks/PutPostPatchFetch";
import { ROUTE_REGIONAL_SETTINGS, ROUTE_REGIONAL_SETTINGS_UPDATE } from "../../routes/Routes";
import { useLocation, useNavigate } from "react-router-dom";
import { buttonTypeNames, formGroupNames } from "../../BuildingsPage/Shared/shared";
import usePageTitle from "../../hooks/usePageTitle";
import FormConfig from "../../FormConfig/FormConfig";


const RegionalSettingsUpdate = () => {
    const navigate = useNavigate();
    const { state: selectedRowData } = useLocation();
    useEffect(() => { getRegions() }, [])
    const regionSetting = Object.fromEntries(
        Object.entries(selectedRowData)
    );

    const [formData, setFormData] = useState(regionSetting);
    const [disabledButton, setDisabledButton] = useState(true);
    const [readOnly, setReadOnly] = useState(true);
    const [regions, setRegions] = useState([]);
    const [backButtonVisibility, setBackButtonVisibility] = useState(true);
    const [cancelButtonVisibility, setCancelButtonVisiblity] = useState(false);
    const [editButtonVisibility, setEditButtonVisibility] = useState(true);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });

    const getRegions = async () => {
        const { Success, Message, Errors } = await GetFetch('/v1/Region');

        if (Success) { 
            setRegions(Message.map(({ RegionNumber }) => RegionNumber));
            setDisabledButton(false);
        };

        if (Errors.length > 0) {
            setDisabledButton(true);
            console.error(Errors);
        };
    }; 

    const { title } = ROUTE_REGIONAL_SETTINGS_UPDATE;
    usePageTitle(title);

    const handleEditButtonClick = () => {
        editButtonVisibility === true ? (
            setBackButtonVisibility(false),
            setCancelButtonVisiblity(true),
            setEditButtonVisibility(false),
            setReadOnly(false)
        ) : (
            setBackButtonVisibility(true),
            setCancelButtonVisiblity(false),
            setEditButtonVisibility(true),
            setReadOnly(true)
        );
    };

    const handleCancelButtonClick = () => {
        cancelButtonVisibility === true ? (
            setBackButtonVisibility(true),
            setCancelButtonVisiblity(false),
            setEditButtonVisibility(true),
            setFormData(regionSetting),
            setReadOnly(true)
        ) : (
            setBackButtonVisibility(false),
            setCancelButtonVisiblity(true),
            setEditButtonVisibility(false),
            setReadOnly(false)
        );
    };

    const handleFormSubmission = async () => {
        const { Errors, Success } = await PutPostPatchFetch(
            "/v1/Region/UpdateSettingsByRegion",
            "POST",
            {
                RegionNumber: formData.RegionNumber,
                inflationRate: formData.InflationRate,   
            }
        );

        if (Success) {
            setBackButtonVisibility(true);
            setCancelButtonVisiblity(false);
            setEditButtonVisibility(true);
            setNotification({
                isVisible: true,
                message: `Region ${formData.RegionNumber} was updated, successfully.`,
                type: 'success'
            });
            setReadOnly(true);
        };

        if (Errors.length > 0) {
            setBackButtonVisibility(false);
            setCancelButtonVisiblity(true);
            setEditButtonVisibility(false);
            setNotification({
                isVisible: true,
                message: `Region ${formData.RegionNumber} was not successfully updated.\nReason: ${Errors}`,
                type: 'error'
            });
            setReadOnly(false);
        };
    };

    const childProps = {
        buttonConfiguration: [
            {
                buttonType: 'Back',
                icon: 'back',
                label: 'Back',
                onClick: () => navigate(ROUTE_REGIONAL_SETTINGS.withSlash),
                type: 'default',
                variant: 'outlined',
                visible: backButtonVisibility,
            },
            {
                buttonType: 'Cancel',
                icon: 'undo',
                label: 'Cancel',
                onClick: handleCancelButtonClick,
                type: 'default',
                variant: 'outlined',
                visible: cancelButtonVisibility
            },
            {
                disabled: disabledButton,
                buttonType: 'Edit',
                icon: 'edit',
                label: 'Edit',
                onClick: handleEditButtonClick,
                type: 'default',
                variant: 'contained',
                visible: editButtonVisibility
            },
            {
                buttonType: 'Save',
                icon: 'save',
                label: 'Save',
                onClick: handleFormSubmission,
                type: 'default',
                variant: 'contained',
                visible: cancelButtonVisibility
            },
        ],
        formConfiguation: {
            columnCount: 24
        },
        formFieldsConfiguration: [
            {
                colSpan: 4,
                fieldType: buttonTypeNames.selectBox,
                formGroupName: formGroupNames.administrative,
                label: 'Region',
                onValueChanged: ({ value }) => setFormData({ ...formData, RegionNumber: value }),
                options: regions,
                readOnly: true,
                requiredRule: true,
                requiredRuleMessage: 'Region is required',
                value: formData.RegionNumber
            },
            {
                colSpan: 4,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.administrative,
                label: 'Inflation Rate',
                onValueChanged: ({ value }) => setFormData({ ...formData, InflationRate: value }),
                readOnly: readOnly,
                value: Math.round(formData.InflationRate * 10) / 10
            },
        ],
        notification,
        title: `${title}: Region ${formData.RegionNumber}`
    };

    return <FormConfig { ...childProps } />
};

export default RegionalSettingsUpdate;